import { useState } from "react";
import Input from "../ui/InputForm";
import Button from "../ui/Button";
import "./AuthForm.css";

function ResetPasswordForm({ onSubmit }) {
  const [formData, setFormData] = useState({
    password: "",
    confirmPassword: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) onSubmit(formData);
  };

  return (
    <form className="auth-form" onSubmit={handleSubmit}>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div className="reset-icon">
          <img src="/icons/lock.png" />
        </div>
      </div>
      <h2>Kies een nieuw wachtwoord</h2>
      <p>Jouw nieuwe wachtwoord moet verschillen van je vorige wachtwoord</p>

      <Input
        label="Wachtwoord"
        type="password"
        name="password"
        placeholder="Nieuw wachtwoord"
        value={formData.password}
        onChange={handleChange}
        required
      />

      <Input
        label="Bevestig wachtwoord"
        type="password"
        name="confirmPassword"
        placeholder="Herhaal wachtwoord"
        value={formData.confirmPassword}
        onChange={handleChange}
        required
      />

      <ul className="password-rules">
        <li>
          <img src="/icons/check.png"/>
          Minimaal 8 karakters
        </li>
        <li>
          <img src="/icons/check.png"/>
          Minimaal 1 speciaal karakter
        </li>
      </ul>

      <Button type="submit" variant="primary" fullWidth>
        Reset wachtwoord
      </Button>

      <a href="/login" className="forgot-link">← Terug naar Login</a>
    </form>
  );
}

export default ResetPasswordForm;